<template>
  <div class="flex-col">
    <div
      :ref="controlRef"
      style="height: 100%"
    >
      <div
        v-show="editingMode"
        class="flex items-center h-full"
      >
        <div class="w-full h-full">
          <div
            class="ms-combobox flex"
            :class="{
              isValid: errorProvider.isValid,
              'border-radius-box': showList,
              disabled: disabled
            }"
          >
            <div
              v-if="showList"
              class="p-relative icon-tree-select"
            >
              <slot name="icon" />
            </div>
            <div
              class="selected-options"
              :style="{
                maxHeight: maxHeight + 'px !important',
                minHeight: minHeight + 'px !important'
              }"
              @click="expand(!expanded)"
            >
              <DxScrollView
                :style="{ height: showScroll == 'always' ? '100px' : 'auto' }"
                :show-scrollbar="showScroll"
                width="100%"
              >
                <div
                  ref="items"
                  class="h-full flex"
                  style="flex-flow: wrap"
                >
                  <div
                    v-for="(item, index) in listSelectedItem"
                    v-show="!showList"
                    :key="index"
                    class="selected-item"
                    :class="{ 'border-radius-item': borderRadius }"
                  >
                    <slot
                      name="selected-item"
                      :data="item"
                    >
                      <div class="item-text m-r-4">
                        {{ item[displayField] }}
                      </div>
                    </slot>
                    <div
                      class="item-icon mi-close-small cursor-pointer"
                      @click.stop="deSelect(item, valueField)"
                    />
                  </div>
                  <input
                    ref="input"
                    v-model="inputText"
                    class="ms-input ms-input-combobox-multiple"
                    :placeholder="placeholder"
                    :disabled="disabled"
                    :class="{ readOnly: disabled }"
                    :autofocus="autofocus"
                    tabindex="1"
                    v-on="listeners"
                    @keyup.tab="expand(!expanded)"
                  >
                </div>
              </DxScrollView>
            </div>
            <!-- <ms-tooltip v-if="!disabled && errorProvider.isValid" :showTooltips="false">
              <template v-slot:text>{{errorProvider.message}}</template>
              <div class="p-l-8">
                <div class="mi mi-20 mi-icon-error mr-2"></div>
              </div>
            </ms-tooltip> -->
            <div
              class="icon-combo--dropdown"
              :class="{ readOnly: disabled, 'no-border': !hasBorderLeft }"
              @click="expand(!expanded)"
            >
              <div
                v-show="!showList"
                :class="['mi-chevron-down']"
              />
            </div>
            <!-- <transition name="dropdownx"> -->
            <ms-combo-box-dropdown
              v-if="expanded"
              ref="dropdownPanel"
              :topx="dropdownTopx"
              :leftx="dropdownLeftx"
              :max-widthx="dropdownMaxWidthx"
              :min-widthx="dropdownMinWidthx"
              :columnx="columns"
              :combo-type="comboType"
              :loading="loading"
              :empty-text="null"
              :show-empty-text="showEmptyText"
              :margin-top-dropdown="marginTopDropdown"
              :class="{ 'ms-combo-box-dropdown-footer': $slots.footer }"
            >
              <button
                v-if="useSelectAll"
                class="add-all flex items-center"
                :class="{ 'selected-all': isSelectAll }"
                @click="selectAll"
              >
                <div
                  v-if="showCheckBoxSelectAll"
                  class="m-r-16"
                  :class="{
                    'mi-square-check':
                      listSelectedItem.length == internalDataSource.length,
                    'mi-square':
                      listSelectedItem.length != internalDataSource.length
                  }"
                />
                <span class="text-bold p-l-8">{{ selectAllText }}</span>
              </button>
              <MsRecycleScroller
                v-if="internalDataSource.length > 0"
                ref="scroller"
                :style="styleScroller"
                :items="internalDataSource"
                :item-size="itemSize"
                key-field="__vKeyValue"
                :emit-update="true"
                :buffer="0"
                :visiable-index="typeAheadPointer"
                @visible="onScrollerVisible"
                @update="onScrollerUpdate"
              >
                <!-- :visiableIndex="typeAheadPointer" -->
                <!-- @visible="onScrollerVisible" -->
                <template #default="{ item, index }">
                  <ms-combo-box-item
                    :combo-type="comboType"
                    :item="item"
                    :columnx="columns"
                    :value-field="valueField"
                    :value="value"
                    :display-field="displayField"
                    :show-checkbox="showCheckbox"
                    :show-icon-check="showIconCheck"
                    :class="{
                      'ms-combobox-item--highlight':
                        !showCheckbox &&
                        value &&
                        (item[valueField] || item[valueField] >= 0)
                          ? value.includes(item[valueField])
                          : false,
                      'ms-combobox-item--highlight-2': typeAheadPointer == index
                    }"
                    :item-size="itemSize"
                    @click="onItemClick(item, $event, index)"
                  >
                    <template #item>
                      <slot
                        name="item"
                        :data="item"
                      />
                    </template>
                  </ms-combo-box-item>
                  <!-- :removeButton="hasRemoveItemButton" -->
                  <!-- :class="{'combobox-item--highlight': (typeAheadPointer == index)}" -->
                  <!-- @click="onItemClick(item,$event)"
                  @removeItem="onRemoveItemClick(item)"-->
                  <!-- :align="internalAlign" -->
                </template>
              </MsRecycleScroller>
              <slot name="footer" />
            </ms-combo-box-dropdown>
            <!-- </transition>    -->
          </div>
          <DxList
            v-show="listSelectedItem.length > 0 && showList"
            :data-source="listSelectedItem"
            :height="DxListHeight"
            :width="'100%'"
            :class="{ 'max-height': DxListHeight == 'auto' }"
            :no-data-text="''"
            style="border: 1px solid #e0e0e0; border-top: none"
          >
            <template #item="{ data }">
              <div class="item-wrap">
                <img
                  :src="data['Avatar']"
                  class="item-image"
                >
                <div class="item-wrap-detail">
                  <div class="item-name">
                    <slot
                      name="list"
                      :data="data"
                    />
                  </div>
                  <i
                    class="mi-close-small"
                    style="background-color: red !important"
                    @click.stop="deSelect(data, valueField)"
                  />
                </div>
              </div>
            </template>
          </DxList>
        </div>

        <div
          v-if="editable"
          ref="btn-save-cancel"
          class="flex m-l-8"
        >
          <ms-icon
            icon="mi-file-green"
            :tooltip-content="$t('i18nCommon.Save')"
            @click="saveEditMode"
          />
          <ms-icon
            icon="mi-circle-close-red"
            :tooltip-content="$t('i18nCommon.Cancel2')"
            @click="closeEditMode"
          />
        </div>
      </div>
      <div
        v-show="editable && !editingMode"
        class="flex"
        @dblclick="onDoubleClick"
      >
        <ms-text-border class="text-border">
          <slot
            v-if="!internalText"
            name="noData"
          />
          <span
            v-else
            :title="internalText"
          >{{ internalText }}</span>
          <template #icon>
            <ms-icon
              v-if="permission"
              icon="mi-pencil"
              :tooltip-content="$t('i18nCommon.Edit')"
              @click="clickEditBtn"
            />
            <ms-icon
              v-if="!permission"
              icon="mi-lock"
            />
          </template>
        </ms-text-border>
      </div>
    </div>
    <p
      v-if="
        !disabled &&
          errorProvider.isValid &&
          ((editable && editingMode) || !editable)
      "
      :class="{ 'text-error': errorProvider.isValid }"
    >
      {{ errorProvider.message }}
    </p>
  </div>
</template>
<script>
import MsComboBoxDropdown from "./MsComboBoxDropdown.vue";
import MsComboBoxItem from "./MsComboBoxItem.vue";
import MsRecycleScroller from "../../shared/virtualScroller/MsRecycleScroller.vue";
import commonFunc from "../../../commons/commonFunction";
import msBaseComponent from "@/components/controls/msbase/msBaseComponent.vue";
import _ from "lodash";
import DxList from "devextreme-vue/list";
import { DxScrollView } from "devextreme-vue/scroll-view";
import { MsControlRef } from "@/models/enums/MsControlRefConst.js";

export default {
  name: "MsComboboxMultiple",
  components: {
    MsComboBoxDropdown,
    MsRecycleScroller,
    MsComboBoxItem,
    DxList,
    DxScrollView,
  },
  extends: msBaseComponent,
  props: {
    selectAllText: {
      default: "Chọn tất cả",
      type: [Number, String],
    },
    value: {
      default: () => [],
    },
    placeholder: {
      default: null,
      type: [Number, String],
    },
    maxItemsDisplay: {
      default: 5,
      type: Number,
    },
    columns: {
      type: Array,
      default: () => [],
    },
    showList: {
      type: Boolean,
      default: false,
    },
    showCheckbox: {
      type: Boolean,
      default: false,
    },
    showIconCheck: {
      type: Boolean,
      default: true,
    },
    DxListHeight: {
      type: [Number, String],
      default: "auto",
    },
    /**
     * Trường làm value
     * CreatedBy LTDAT 15.06.2020
     */
    valueField: {
      type: String,
      default: null,
    },
    /**
     * Trường làm text display
     * CreatedBy LTDAT 15.06.2020
     */
    displayField: {
      type: String,
      default: null,
    },
    //Dữ liệu của combobox
    data: {
      default: () => [],
      type: Array,
    },
    //Độ rộng của 1 item
    itemSize: {
      default: 36,
      type: Number,
    },
    maxHeight: {
      default: 100,
      type: Number,
    },
    minHeight: {
      default: 34,
      type: Number,
    },
    //Chỉ nhận giá trị có trong danh sách
    forceSelection: {
      default: true,
      type: Boolean,
    },
    //Là combotree hay không
    isComboTree: {
      default: false,
      type: Boolean,
    },
    //Parent Field
    idProperty: {
      default: null,
      type: String,
    },
    //Field chứa parentID
    parentIdProperty: {
      default: "ParentID",
      type: String,
    },
    //Không cho phép chọn trường là cha
    notSelectionParent: {
      default: false,
      type: Boolean,
    },
    //Độ rông của dropdown tính bằng px
    dropdownWidth: {
      default: null,
      type: [String, Number],
    },
    //Store xử lý dữ liệu trên liên quan đến data trong grid
    store: {
      default: null,
    },
    //Mode query lấy dữ liệu từ server hay client
    queryMode: {
      type: String,
      default: "remote",
    },
    //Gán giá trị text lúc ban đầu
    initText: {
      default: null,
      type: [Number, String],
    },
    //Trạng thái có phân trang hay không
    pagination: {
      default: false,
      type: Boolean,
    },
    hasBorderLeft: {
      type: [String, Boolean],
      default: false,
    },
    // function để call API lấy các list options
    doQueryFuntion: Function,
    // các cột được search khi call API
    searchColums: Array,
    autofocus: {
      default: false,
      type: [Boolean, String],
    },
    // Item khởi tạo dữ liệu cho v-model
    initItems: {
      type: Array,
      default: () => [],
    },
    // có sử dụng chọn tất cả (chỉ nên áp dụng khi queryMode là local)
    useSelectAll: {
      type: Boolean,
      default: false,
    },
    //Lưu dữ liệu định danh combobox
    dataInfo: {
      default: () => {},
      type: Object,
    },
    //Ẩn hiện icon checkbox bên cạnh textSelectAll
    showCheckBoxSelectAll: {
      type: Boolean,
      default: true,
    },
    paramValidate: {
      type: [Object, Array],
    },
    editable: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    marginTopDropdown: {
      type: String,
      default: null,
    },
    borderRadius: {
      type: Boolean,
      default: false,
    },
    permission: {
      type: Boolean,
      default: true,
    },
    // sử dụng cho sự kiện scroll cha thì ẩn combobox chọn đi
    scrollParent: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const me = this;
    me.initStaticData();
    return {
      inputText: null,
      controlRef: MsControlRef.MsComboboxMultiple,
      expanded: false,
      dropdownTopx: 0,
      dropdownLeftx: 0,
      internalSelectedItem: null,
      typeAheadPointer: -1,
      listSelectedItem: [],
      internalDataSource: [],
      loading: false,
      showEmptyText: false,
      internalText: this.value ? this.value.join("") : null,
      timeoutQuery: null,
      timeoutClickOutside: null,
      // set chế độ edit = fasle khi editable = true
      editingMode: !this.editable,
      oldValue: null,
      // có cho phép kích hoạt sự kiện blur
      isAllowBlurEvent: true,
      showScroll: "never",
    };
  },
  computed: {
    listeners() {
      const me = this;
      return {
        input: (event) => me.onInput(event),
        focus: (event) => me.onFocus(event),
        change: (event) => me.onChange(event),
        blur: (event) => me.onBlur(event),
        keydown: (event) => me.onKeydown(event),
      };
    },
    //Tính độ rộng của dropdown combobox để scroll
    styleScroller() {
      const me = this;
      return { "max-height": me.maxItemsDisplay * me.itemSize + "px" };
    },
    isEditingMode() {
      return this.$store.getters.getEditingMode;
    },
  },
  watch: {
    /**
     * custom validate
     * modifiedBy: vtminh (12/5/2021)
     */
    paramValidate: {
      immediate: true,
      handler(val) {
        let me = this;

        //Nếu validate đang true và kphai custom thì return
        if (
          me.errorProvider &&
          me.errorProvider["isValid"] &&
          (!val || (val && me.errorProvider["rules"] != val.rules))
        ) {
          return;
        }

        if (val && val.isValid) {
          me.$set(me.errorProvider, "message", val.message);
          me.$set(me.errorProvider, "isValid", true);
          me.errorProvider.rules = val.rules;
          me.errorProvider.element = me.$refs.input;
        } else {
          me.errorProvider = {};
        }
      },
    },
    data: {
      immediate: true,
      handler(newVal, oldVal) {
        const me = this;
        if (newVal != me.internalDataSource) {
          me.initData();
        }
      },
    },
    /**
     * Set lại giá trị hiển thị khi giá trị của biến initText thay đổi
     */
    initText: {
      immediate: true,
      handler(newVal, oldVal) {
        let me = this;
        me.setInitText(newVal);
      },
    },
    /**
     * Kiểm tra nếu text hiện thị thay đổi thi validate
     */
    inputText: {
      handler(newVal, oldVal) {
        const me = this;
        // me.validate(newVal);
        // me.$emit('input',newVal);
      },
    },
    /**
     * Nếu giá trị VModel của combo thay đổi thì gán lại giá trị mới và select vào item tương ứng có trong data
     */
    value: {
      immediate: true,
      handler(newVal, oldVal) {
        this.internalText = newVal ? newVal.join("") : null;
        const me = this;
        me.initItems &&
          me.initItems.length > 0 &&
          me.internalDataSource.length == 0 &&
          (me.internalDataSource = me.initItems);
        !newVal && (newVal = []);
        !oldVal && (oldVal = []);
        if (!newVal || newVal.length == 0) {
          me.listSelectedItem = [];
          me.reset();
          return;
        }

        let differenceNewVal = newVal.filter((x) => !oldVal.includes(x));
        if (differenceNewVal) {
          if (Array.isArray(differenceNewVal)) {
            differenceNewVal.forEach((item) => {
              me.internalValue = item;
              me.doHightlightItem();
              if (me.typeAheadPointer >= 0) {
                me.listSelectedItem.push(
                  me.internalDataSource[me.typeAheadPointer]
                );
              }
            });
          }
        }

        let differenceOldVal = oldVal.filter((x) => !newVal.includes(x));
        if (differenceOldVal) {
          if (Array.isArray(differenceOldVal)) {
            differenceOldVal.forEach((item) => {
              let index = me.listSelectedItem.findIndex(
                (e) => item == e[me.valueField]
              );
              index > 0 && me.listSelectedItem.splice(index, 1);
            });
          }
        }

        me.internalText =
          me.listSelectedItem && me.listSelectedItem.length
            ? me.listSelectedItem.map((e) => e[me.displayField]).join("; ")
            : "";
        me.validate(me.internalText);
        setTimeout(() => {
          me.showScroll =
            this.$refs["items"].offsetHeight > 100 ? "always" : "never";
        }, 200);
      },
    },
    expanded(val) {
      if (!val && this.inputText) {
        this.inputText = null;
        this.doQuery(this.inputText, false);
      }
    },
    editable: {
      immediate: true,
      handler(val) {
        this.$store.dispatch("setEditingMode", false);
        this.editingMode = !val;
      },
    },

    /**
     * ẩn combobox đang chọn đi khi thằng cha scroll
     * dvquang2 30/08/2021
     */
    scrollParent: {
      //immediate: true,
      handler(val) {
        this.expand(false);
      },
    },
  },
  //Hàm khởi tạo dữ liệu hook func
  created() {
    const me = this;
    me.initCombo();
    me.initData();
    me.setInitText();
    // if(this.value && this.value.length > 0){
    //   this.listSelectedItem = this.value;
    // }
  },
  mounted() {
    const me = this;
    //Debounce query để delay load
    if (me.queryMode != "remote") {
      me.internalQueryDelay = 20;
    }
    me.doQuery = _.debounce(me.doQueryInternal, me.internalQueryDelay);
    if (me.store) {
      me.store.pageAppend = true;
    }
    if (this.autofocus) {
      this.$nextTick(() => this.$refs.input.focus());
    }
  },
  beforeDestroy() {
    const me = this;
    me.firstExpand = false;
    me.expand(false);
    if (me.$refs.dropdownPanel) {
      me.$refs.dropdownPanel.$el.remove();
    }
    document.removeEventListener("click", me.click_out);
  },
  methods: {

    /**
     * @override
     */
    focusError(){
      this.expanded = true;
    },
    onDoubleClick() {
      this.permission && this.clickEditBtn();
    },
    /**
     * Hàm convert từ trường tiếng việt sang trường không dấu
     * Created by CVCUONG1 2/2/2021
     */
    stringToSlug(str) {
      if (!str) return "";
      var from =
          "àáãảạăằắẳẵặâầấẩẫậèéẻẽẹêềếểễệđùúủũụưừứửữựòóỏõọôồốổỗộơờớởỡợìíỉĩịäëïîöüûñçýỳỹỵỷ",
        to =
          "aaaaaaaaaaaaaaaaaeeeeeeeeeeeduuuuuuuuuuuoooooooooooooooooiiiiiaeiiouuncyyyyy";
      for (var i = 0, l = from.length; i < l; i++) {
        str = str.replace(RegExp(from[i], "gi"), to[i]);
      }

      str = str
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9\-]/g, "-")
        .replace(/-+/g, "-");

      return str;
    },
    deSelect(item, valueField) {
      let me = this,
        VModel = me.value ? [...me.value] : [];
      let oldListData = [...me.listSelectedItem];
      me.listSelectedItem.remove(item);
      VModel.remove(item[valueField]);
      item.__multiSelected = false;
      me.$emit("input", VModel);
      me.$emit("onRemoveItem", item);
      me.isSelectAll = false;
      if (me.listSelectedItem.length == 0) {
        me.internalText = null;
        me.validate(me.internalText);
      }
      let metaData = {
        oldListData: [...oldListData],
        newListData: [...me.listSelectedItem],
      };
      me.$emit("selected", metaData, me.dataInfo);
    },
    /**
     * Kiểm tra scroll đã đến bản ghi cuối cùng hay chưa
     * Nếu load theo kiểu phân trang và số bản ghi trong combo nhỏ hơn tổng số bản ghi thi load tiếp dữ liệu vào store
     * @param start: vị trí bắt đầu của view trong vitual scroll
     * @param end: vị trí kết thúc của view trong vitual scroll
     * Created by LTDAT(30.06.2020)
     *  */
    onScrollerUpdate(start, end) {
      const me = this;
      if (
        end == me.internalDataSource.length &&
        end < me.pageTotal &&
        start == me.internalDataSource.length - 5 &&
        !me.loading
      ) {
        me.loading = true;
        me.doRemoteQuery(
          me.getQueryString(),
          me.searchColums,
          Math.round(end / 10) + 1
        ).then((x) => {
          if (x && x.PageData && x.PageData.length > 0) {
            me.internalDataSource.push(...x.PageData);
            commonFunc.genVKeyValue(me.internalDataSource);
          }
          me.loading = false;
          // me.afterQuery(expand);
        });
      }
    },
    /**
     * Set giá trị hiện thị ban đầu cho combobox khi combo chưa có dữ liệu
     * Created by LTDAT(25.06.2020)
     */
    setInitText() {
      const me = this;
      me.inputText = me.initText;
    },
    /**
     * Thực hiện query dữ liệu, có thể từ local hoặc remote tùy theo cấu hình
     * CreatedBy LTDAT 11/12/2019
     */
    doQueryInternal(searchString, expand = true) {
      let me = this,
        event = { preventDefault: false, sender: me },
        queryString = searchString != null ? searchString : me.getQueryString();
      me.$emit("beforeQuery", event);
      if (event.preventDefault) {
        return false;
      }
      if (me.lastQueryString == queryString) {
        me.expand(expand);
      } else {
        me.lastQueryString = queryString;
        me.querying = true;
        me.typeAheadPointer = -1;
        if (me.queryMode === "remote") {
          me.loading = true;
          me.showEmptyText = false;
          me.doRemoteQuery(queryString, me.searchColums).then((x) => {
            me.internalDataSource = (x && x.PageData) || [];
            me.pageTotal = (x && x.Total) || 0;
            me.loading = false;
            (!x || !x.PageData || x.PageData == 0) && (me.showEmptyText = true);
            commonFunc.genVKeyValue(me.internalDataSource);
            me.afterQuery(expand);
          });
        } else {
          me.doLocalQuery(queryString).then((x) => me.afterQuery(expand));
        }
      }
    },
    /**
     * Xử lý sau khi query xong dữ liệu
     * CreatedBy LTDAT 24.06.2020
     */
    afterQuery(expand) {
      const me = this;
      me.expand(expand);
      me.typeAheadPointer = me.filterIndexItemByText();
    },
    /**
     * Query dữ liệu api
     * CreatedBy LTDAT 24.06.2020
     */
    doRemoteQuery(queryString, searchColums, pageIndex = 1) {
      let me = this;
      return new Promise((resolve, reject) => {
        me.doQueryFuntion(queryString, searchColums, pageIndex)
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    /**
     * Query dữ liệu local
     * CreatedBy LTDAT 24.06.2020
     */
    doLocalQuery(queryString) {
      let me = this,
        store = me.store;

      return new Promise((resolve, reject) => {
        //Kiểm xem store đã load dữ liệu chưa, nếu chưa thì load lần đầu
        let p;
        if (me.autoLoad && store && !store._loaded && store.getCount() == 0) {
          var proxy = store.proxy;
          if (proxy && proxy.type === "cache") {
            p = store.load();
          }
        }
        // if (store && store.proxy && store.proxy.type === 'cache') {
        // 	p = clientDatabase.fetchKey(store.proxy.keyCache).then(res => {
        // 		//Nếu cache thay đổi thì load lại
        // 		if (res) {
        // 			store.load();
        // 		}
        // 	});
        // }
        p ? p.then(resolve, reject) : resolve(false);
      }).then(() => {
        me.loading = false;
      });
    },
    /**
     * Lấy chuỗi cần query, trường hợp number thì lấy value bỏ qua ký tự phân cách
     * CreatedBy LTDAT 11/12/2019
     */
    getQueryString() {
      return (this.inputText || "").trim();
    },
    //Click ra ngoài combo đóng combo lại
    //Created by LTDAT 18.06.2020
    click_out(e) {
      const me = this;
      if (
        me.$el &&
        !commonFunc.hasParent(e.target, me.$el) &&
        !commonFunc.hasParent(e.target, me.$refs.dropdownPanel.$el)
      ) {
        me.expand(false);
      }
    },
    //Reset lại các giá trị trong combobox
    reset() {
      const me = this;
      me.inputText = "";
      me.internalSelectedItem = null;
      me.typeAheadPointer = -1;
      me.internalValue = null;
      me.$emit("input", me.internalValue);
    },
    resetAll() {
      this.internalDataSource = [];
      this.firstExpand = true;
      this.lastQueryString = undefined;
      this.reset();
      this.$emit("selected", []);
      this.showScroll = "never";
    },
    setinputText(value) {
      const me = this;
      me.inputText = value;
    },
    setValue(value) {
      const me = this;
      me.internalValue = value;
      me.$emit("input", me.internalValue);
    },
    //Sự kiện nhập liệu trên input
    //Created by LTDAT (16.06.2020)
    onInput(e) {
      const me = this;
      if (!me.expanded) {
        me.expand(true);
      }
      if (me.queryMode == "remote") {
        clearTimeout(this.timeoutQuery);
        this.timeoutQuery = setTimeout(() => {
          me.doQuery(me.inputText, true);
        }, 300);
      } else {
        // Xử lý khi tìm kiếm queryMode = local
        me.showEmptyText = false;
        me.internalDataSource = me.data.filter((d) =>
          me
            .stringToSlug(d[this.displayField])
            .toLowerCase()
            .includes(me.stringToSlug(me.inputText).toLowerCase())
        );
        if (me.internalDataSource.length == 0) me.showEmptyText = true;
        me.typeAheadPointer = me.filterIndexItemByText();
      }
      // if(itemSelected)
      // {
      //     onItemClick(itemSelected,e);
      // }
    },
    //Sự kiện focus vào input
    //Created by LTDAT (16.06.2020)
    onFocus(e) {
      const me = this;
      me.focused = true;
      clearTimeout(me.timeoutClickOutside);
      me.showList && me.expand(true);
    },
    //Sự kiện change input
    //Created by LTDAT (16.06.2020)
    onChange(e) {},
    //Sự kiện blur input
    //Created by LTDAT (16.06.2020)
    onBlur(e) {
      if (this.isAllowBlurEvent) {
        const me = this;
        me.focused = false;
        me.timeoutClickOutside = setTimeout(() => {
          me.expand(false, false);
        }, 200);
      } else {
        this.$refs.input.focus();
      }
    },
    /**
     * Xử lý khi mouse down chuột
     * created by pdthien 24.02.2021
     */
    handleMouseDown() {
      this.isAllowBlurEvent = false;
    },
    /**
     * Xử lý khi mouse up chuột
     * created by pdthien 24.02.2021
     */
    handleMouseUp() {
      this.isAllowBlurEvent = true;
      this.$refs.input.blur();
    },
    //Sự kiện keydown input
    //Created by LTDAT (16.06.2020)
    onKeydown(e) {
      const me = this;
      switch (e.which) {
        case 40:
          {
            if (!me.expanded) {
              me.expand(true);
            } else if (me.typeAheadPointer < me.getTotalData() - 1) {
              if (me.notSelectionParent) {
                let typeAheadPointerNext = me.typeAheadPointer + 1;
                for (let i = typeAheadPointerNext; i < me.getTotalData(); i++) {
                  me.typeAheadPointer++;
                  me.adjustScroll(typeAheadPointerNext);
                  if (!me.internalDataSource[i].isParent) {
                    break;
                  }
                }
              } else {
                me.typeAheadPointer++;
                me.adjustScroll();
              }
            }
          }
          break;
        case 38:
          {
            if (me.expanded) {
              if (me.typeAheadPointer > 0) {
                if (me.notSelectionParent) {
                  let typeAheadPointerPre = me.typeAheadPointer - 1;
                  for (let i = typeAheadPointerPre; i > 0; i--) {
                    me.typeAheadPointer--;
                    me.adjustScroll(me.typeAheadPointer);
                    if (!me.internalDataSource[i].isParent) {
                      break;
                    }
                  }
                } else {
                  me.typeAheadPointer--;
                  me.adjustScroll();
                }
              }
            }
          }
          break;
        case 13:
          {
            event.preventDefault();
            if (me.typeAheadPointer >= 0 && me.expanded) {
              me.setInternalItem(me.internalDataSource[me.typeAheadPointer]);
            }
            me.expand(false);
          }
          break;
        case 9:
          {
            if (me.expanded) {
              me.expand(false);
            }
          }
          break;
      }
    },
    getTotalData() {
      const me = this;
      return me.internalDataSource.length;
    },
    //Bôi màu hightlight cho item
    doHightlightItem() {
      const me = this;
      if (me.internalDataSource) {
        if (me.internalDataSource.length > 0) {
          if (me.internalValue != null && me.internalValue != undefined) {
            //Trước khi load tính toán lại typeAheadPointer nếu cần thiết để scroll di chuyển về dúng vị trí khi show scroller lên
            //Tìm vị trí selectedItem trong source, không lấy selectedIndex vì có thể không chính xác khi source thay đổi
            let index = _.findIndex(
              me.internalDataSource,
              (item) => item[me.valueField] == me.internalValue
            );
            me.typeAheadPointer = index;
          }
        }
      }
    },
    //Tìm kiếm item trong list
    //Created by LTDAT(16.06.2020)
    filterIndexItemByText() {
      const me = this;
      let filters = me.filterFields,
        value = me.inputText,
        index = -1;
      if (filters) {
        index = me.internalDataSource.findIndex((item, _index) => {
          let ret = false;
          for (const key in filters) {
            if (filters.hasOwnProperty(key)) {
              const s = filters[key];
              if (s == "contains") {
                ret =
                  item[key] &&
                  item[key].toString() &&
                  me
                    .stringToSlug(item[key].toString())
                    .toLowerCase()
                    .contains(me.stringToSlug(value).toLowerCase());
              } else {
                ret =
                  item[key] &&
                  item[key].toString() &&
                  me
                    .stringToSlug(item[key].toString())
                    .toLowerCase()
                    .startsWith(me.stringToSlug(value).toLowerCase());
              }
              if (ret) {
                break;
              }
            }
          }
          return ret;
        });
      }
      me.adjustScroll();
      return index;
    },
    //Lấy cột filter để tìm kiếm local
    //Created by LTDAT 16.06.2020
    getFilterFields() {
      let filter = {};

      if (this.columns && this.columns.length > 0) {
        for (let i = 0; i < this.columns.length; i++) {
          const col = this.columns[i];
          if (!col.filterOperator) {
            col.filterOperator = "contains";
          }
          if (col.dataField && col.filterOperator) {
            if (this.filterColumns && this.filterColumns.length > 0) {
              this.filterColumns.forEach((e) => {
                if (!filter.hasOwnProperty(e)) {
                  filter[e] = col.filterOperator;
                }
              });
            } else {
              filter[col.dataField] = col.filterOperator;
            }
          }
        }
      } else {
        filter[this.displayField] = "contains";
      }
      return filter;
    },
    //Lấy element scroll
    //Created by LTDAT (16.06.2020)
    getScroller() {
      if (this.expanded) {
        return this.$refs["scroller"];
      }
      return null;
    },
    /**
     * Di chuyển view đến bản ghi nếu cần
     * @param {Bản ghi cần view} index
     * CreatedBy LTDAT 16.06.2020
     */
    adjustScroll(typeAheadPointer = this.typeAheadPointer) {
      let scroller = this.getScroller();
      //console.log("scroller index " + this.typeAheadPointer);
      if (scroller) {
        scroller.scrollToItem(typeAheadPointer, true);
      }
    },
    onScrollerVisible() {
      const me = this;
      me.adjustScroll();
    },
    //Hàm xử lý khi chọn item trên dropdown
    //Created by LTDAT(16.06.2020)
    onItemClick(item, event, index) {
      const me = this;
      me.setInternalItem(item);
      me.typeAheadPointer = index;
      me.$refs.input.focus();
    },
    //Set giá trị được chọn
    setInternalItem(item) {
      const me = this;
      if (me.notSelectionParent && item.isParent) {
        return;
      }

      let metaData = {
        oldData: me.internalSelectedItem,
        newData: item,
        oldListData: me.listSelectedItem,
        newListData: [...me.listSelectedItem, item],
      };
      me.internalSelectedItem = item;
      me.internalValue = item[me.valueField];
      let itemInLists = me.listSelectedItem.find((_item) => {
        return _item[me.valueField] == item[me.valueField];
      });
      let VModel = me.value ? [...me.value] : [];
      if (!VModel) {
        VModel = [];
      }

      if (itemInLists) {
        me.listSelectedItem = me.listSelectedItem.filter(
          (e) => e[me.valueField] != item[me.valueField]
        );
        VModel = VModel.filter((e) => e != me.internalValue);
        item.__multiSelected = false;
        me.$emit("input", VModel);
        me.$emit("onRemoveItem", item);
        metaData.newListData = me.listSelectedItem;
        me.$emit("onRemove", me.listSelectedItem, metaData, me.dataInfo);
      } else {
        // me.listSelectedItem.push(item);
        VModel.push(me.internalValue);
        item.__multiSelected = true;
        me.$emit("input", VModel);
        me.$emit("selected", metaData, me.dataInfo);
      }
      // if (me.inputText) me.doQuery("", true);
      // me.inputText = null;
      me.internalText = item[me.displayField];
    },
    //Tìm vị trị của item trong data
    findIndexItem(item) {
      const me = this;
      return me.internalDataSource.findIndex((_item) => {
        return _item == item;
      });
    },
    //Khởi tạo dữ liệu tĩnh mặc định
    initStaticData() {
      const me = this;
      me.comboType = 1;
      me.internalDataSource = [];
      me.internalQueryDelay = 200;
      me.filterFields = me.getFilterFields();
      me.focused = false;
      me.internalValue = null;
      me.firstExpand = true;
    },
    //Khởi tạo dữ liệu
    initData() {
      const me = this;
      if (me.store) {
        me.internalDataSource = me.store.data.items;
      } else {
        me.internalDataSource = me.data;
      }
      commonFunc.genVKeyValue(me.internalDataSource);
      //Nếu là combo dạng tree
      if (me.comboType == 3) {
        let dataTree = commonFunc.nomalizeDataTree(
          me.internalDataSource,
          me.idProperty,
          me.parentIdProperty
        );
        me.internalDataSource = commonFunc.getBodyData(dataTree, true);
      }
    },
    /**
     * Khởi tạo combo
     *
     * @author hngiap - 01.09.2019
     * 1 là combo không có columns (ComboEditor)
     * 2 là combo có columns
     * 3 là combo tree
     */
    initCombo() {
      let me = this;
      if (me.isComboTree) {
        me.comboType = 3;
      } else if (me.columns && me.columns.length !== 0) {
        me.comboType = 2;
      } else {
        me.comboType = 1;
      }
    },
    //Đóng mở combobox
    expand(mode = !this.expanded, callAPI = true) {
      /***
       * Emit thêm sự kiện để bind dữ liệu
       * LPLONG - 11/01/2021
       */
      this.$emit("expand", mode);
      const me = this;
      if (me.firstExpand && callAPI) {
        me.firstExpand = false;
        if (me.queryMode == "remote") {
          me.doQueryInternal(null, true);
        }
      }
      if (mode == true) {
        me.$emit("beforeExpand");
        document.addEventListener("click", me.click_out);
      } else {
        document.removeEventListener("click", me.click_out);
      }
      me.expanded = mode;
      me.doHightlightItem();
      mode && me.$refs.input.focus();
      me.changeDropdownPosition();

      let dropdown =
        this.$refs && this.$refs.dropdownPanel && this.$refs.dropdownPanel.$el;
      if (dropdown) {
        if (mode) {
          dropdown.addEventListener("mousedown", this.handleMouseDown);
          dropdown.addEventListener("mouseup", this.handleMouseUp);
        } else {
          dropdown.removeEventListener("mousedown", this.handleMouseDown);
          dropdown.removeEventListener("mouseup", this.handleMouseUp);
        }
      }
    },
    /**
     * Hàm set vị trí cho dropdown menu khi expand
     * TODO: Chưa xử lý khi có scroll
     */
    changeDropdownPosition() {
      let me = this,
        comboEl = me.$el,
        comboElRect = comboEl.getBoundingClientRect(),
        comboMenuEl = me.$el;

      let windowWidth =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;

      let windowHeight =
        window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight;

      me.dropdownLeftx = comboElRect.left;
      me.dropdownTopx = comboElRect.top + comboElRect.height + 2;

      // xử lý điều chỉnh width khi ở chế độ edit trực tiếp
      let btnSaveCancel = this.$refs["btn-save-cancel"];
      let widthBtnSaveCancel = 0;
      if (me.editable && btnSaveCancel)
        widthBtnSaveCancel = btnSaveCancel.clientWidth;

      me.dropdownMaxWidthx = me.dropdownMinWidthx = me.dropdownWidth
        ? me.dropdownWidth - widthBtnSaveCancel
        : comboElRect.width - widthBtnSaveCancel;

      // Nếu chạm phải thì align sang trái
      if (comboElRect.left + comboMenuEl.offsetWidth > windowWidth) {
        me.dropdownLeftx = comboElRect.right - comboMenuEl.offsetWidth;
      }

      // Nếu chạm bottom thì align top
      if (
        comboElRect.bottom + me.itemSize * me.maxItemsDisplay + 2 >
        windowHeight
      ) {
        if (me.internalDataSource.length > 0) {
          me.dropdownTopx =
            comboElRect.top -
            (me.itemSize *
              Math.min(me.maxItemsDisplay, me.internalDataSource.length) +
              8);
        } else {
          me.dropdownTopx = comboElRect.top - me.itemSize + 14;
        }
      }
    },
    /**
     * Hàm xử lý chọn tất cả cho queryMode là local
     * created by pdthien 25.12.2020
     */
    selectAll() {
      this.typeAheadPointer = -1;
      this.isSelectAll = true;
      let metaData = {
        newListData: [...this.data],
      };
      this.expand(false);
      this.$emit(
        "input",
        this.data.map((e) => e[this.valueField])
      );
      this.$emit("selected", metaData, this.dataInfo);
      this.internalText = "Chọn tất cả";
      this.validate(this.internalText);
    },
    /**
     * Hàm focus vào ô input
     * Created by CVCUONG1 20/1/2020
     */
    focusInput() {
      this.$refs.input.focus();
    },
    /**
     * Hàm mở dropdown
     * created pdthien 22.02.2021
     */
    openDropdown() {
      this.expand(true);
    },
    /**
     * Hàm xử lý khi click icon edit
     * created by pdthien 21.01.2021
     */
    clickEditBtn() {
      if (!this.isEditingMode) {
        this.oldValue = this.value;
        this.editingMode = !this.editingMode;
        this.$nextTick(() => this.$refs.input.focus());
        this.$emit("clickEditBtn");
        this.$store.dispatch("setEditingMode", true);
      }
    },
    /**
     * Hàm xử lý khi đóng chế độ edit
     * created by pdthien 21.01.2021
     */
    closeEditMode() {
      this.editingMode = false;
      this.$store.dispatch("setEditingMode", false);
      this.valueX = this.oldValue;
      this.$emit("input", this.oldValue);
      this.$emit("closeEditMode");
    },
    /**
     * Hàm xử lý khi lưu edit
     * created by pdthien 21.01.2021
     */
    saveEditMode() {
      if (!this.errorProvider.isValid) {
        this.$emit("onSaveData");
      }
    },
    /**
     * Hàm set editingMode = false
     */
    closeEditingMode() {
      this.editingMode = false;
      this.$store.dispatch("setEditingMode", false);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/controls/msCombobox.scss";
// .selected-item
// {
// 	background-color: #f2f2f2;
//     border-radius: 1.5px;
//     border: 1px solid #b0bac9;
//     display: flex;
//     overflow: hidden;
//     padding: 2px 5px;
// 	align-items: center;
// 	margin-right: 8px;
// }
.isValid {
  &:hover,
  &:focus-within {
    .selected-options {
      border-right: none !important;
    }
  }
}
.ms-combobox {
  &:hover,
  &:focus-within {
    .selected-options {
      // border-right: 1px solid var(--primary) !important;
    }
  }
}
.selected-options {
  display: flex;
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
  flex-wrap: wrap;
  height: calc(100%);
  max-height: 180px;
  min-height: 34px;
  height: auto;
  width: calc(100% - 36px);
  padding-left: 4px;
  overflow-y: hidden;

  .selected-item {
    display: flex;
    align-items: center;
    border-radius: 4px;
    background-color: #e8eaef;
    padding-left: 8px;
    padding-right: 4px;
    margin: 2px 0;
    border: none;
    height: 26px;
    max-width: calc(100% - 8px);
    width: max-content !important;
    .item-text {
      flex: 1;
      font-size: 14px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }

  .selected-item:not(:last-child) {
    margin-right: 4px;
  }

  .ms-input {
    border: none;
    font-size: $font-size-body;
    text-overflow: ellipsis;
    background-color: transparent;
    display: flex;
    flex: 1;
  }
  .ms-input-combobox-multiple {
    padding: 0px;
  }
  .ms-input::placeholder {
    font-size: 14px;
  }
  .border-radius-item {
    background-color: #f0f0f0;
    border-radius: 16px;
    height: 32px;
    overflow: hidden;
  }
}

.add-all {
  width: 100%;
  background: transparent;
  border: none;
  text-align: left;
  padding-left: 8px;
  height: 36px;
  &:hover {
    background: var(--combobox-highlight-color);
    cursor: pointer;
  }
  &.selected-all {
    background: var(--combobox-highlight-color);
  }
}

.no-data {
  -webkit-box-flex: 1;
  padding: 0 10px;
  font-size: 13px;
  display: flex;
  align-items: center;
  height: 36px;
}
.max-height {
  max-height: 135px;
  overflow-y: auto;
}
.border-radius-box {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.icon-tree-select {
  position: relative;
  left: 8px;
  z-index: 1;
}
</style>

<style lang="scss">
.ms-combobox-item--highlight-2 {
  background: var(--combobox-highlight-bg-2-color) !important;
  color: var(--combobox-color);
  // .item-selected {
  //     background: var( --combobox-highlight-bg-color) !important;
  //     color: var(--combobox-highlight-color);
  // }
}
.ms-combobox-item--highlight {
  * {
    color: var(--combobox-highlight-color) !important;
  }
}
.text-border {
  p {
    display: flex;
    flex-direction: column-reverse;
    padding-left: 8px;
  }
  .mi-pencil {
    opacity: 0;
  }
  &:hover {
    .mi-pencil {
      opacity: 1;
    }
  }
}
</style>
<style>
.ms-combo-box-dropdown-footer {
  padding-bottom: 36px !important;
}
</style>
